(function () {
  var KEY = 'AB Assignment';
  var STORE = '_ab_assignment';

  function waitForShoplift(maxMs) {
    return new Promise(function (resolve, reject) {
      var start = Date.now();
      (function poll() {
        if (window.shoplift && typeof window.shoplift.getVisitorData === 'function') {
          resolve(window.shoplift);
        } else if (Date.now() - start > maxMs) {
          reject(new Error('shoplift unavailable'));
        } else {
          setTimeout(poll, 50);
        }
      })();
    });
  }

  function configs() {
    var inst = window.shopliftInstance;
    if (!inst) return [];
    return [].concat(inst.testConfigs || [], inst.inactiveTestConfigs || []);
  }

  function token(hypothesisId) {
    var hex = String(hypothesisId || '').replace(/-/g, '').toLowerCase();
    return hex.length >= 8 ? hex.slice(-8) : null;
  }

  function describe(entry, list) {
    if (!entry || !entry.testId || !entry.hypothesisId) return null;
    var hid = token(entry.hypothesisId);
    if (!hid) return null;
    if (entry.testTitle && (entry.assignedTo === 'control' || entry.assignedTo === 'variant')) {
      return { title: entry.testTitle, arm: entry.assignedTo, token: hid };
    }
    for (var i = 0; i < list.length; i++) {
      var test = list[i];
      if (!test || test.id !== entry.testId || !test.hypotheses) continue;
      for (var j = 0; j < test.hypotheses.length; j++) {
        var hyp = test.hypotheses[j];
        if (hyp && hyp.id === entry.hypothesisId) {
          return { title: test.title || test.id, arm: hyp.isControl ? 'control' : 'variant', token: hid };
        }
      }
    }
    return null;
  }

  function entries(sl) {
    var tests = [];
    try {
      tests = sl.getVisitorData().visitorTests || [];
    } catch (e) {
      return null;
    }
    var list = configs();
    var seen = {};
    var out = [];
    tests.forEach(function (entry) {
      var found = describe(entry, list);
      if (!found) return;
      var key = found.token + ':' + found.arm;
      if (seen[key]) return;
      seen[key] = true;
      out.push(found);
    });
    return out;
  }

  function assignment(list) {
    return list
      .map(function (e) {
        return e.title + ':' + e.arm + ':' + e.token;
      })
      .join(' | ');
  }

  function abTestsParam(list) {
    var tokens = list.map(function (e) {
      return e.token;
    });
    while (tokens.join(',').length > 36) tokens.shift();
    return tokens.join(',');
  }

  function publish(list) {
    if (!list) return;
    if (typeof window.omniSetAbTests === 'function') window.omniSetAbTests(abTestsParam(list));
    send(assignment(list));
  }

  function send(value) {
    if (!value) return;
    try {
      if (sessionStorage.getItem(STORE) === value) return;
    } catch (e) {}
    var attrs = {};
    attrs[KEY] = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (res) {
        if (!res.ok) return;
        try {
          sessionStorage.setItem(STORE, value);
        } catch (e) {}
      })
      .catch(function () {});
  }

  function run() {
    waitForShoplift(4000)
      .then(function (sl) {
        publish(entries(sl));
        setTimeout(function () {
          publish(entries(sl));
        }, 4000);
      })
      .catch(function () {});
  }

  function start() {
    setTimeout(run, 1500);
  }

  waitForShoplift(4000)
    .then(function (sl) {
      if (typeof window.omniSetAbTests === 'function') {
        var list = entries(sl);
        if (list) window.omniSetAbTests(abTestsParam(list));
      }
    })
    .catch(function () {});

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
